import { useTranslation } from 'react-i18next';

import Title from 'pages/Flights/Title';
import { IFlightTicketRequest } from 'entities/Flights/sdk';
import { FLIGHT_TICKET_PROPOSAL_STATUS_TRANSLATION_KEY_MAP } from 'utils/constants';

const FlightBox = ({ flightTicketRequest }: { flightTicketRequest: IFlightTicketRequest }) => {
  const { t } = useTranslation();

  return (
    <div className='w-[330px] h-[312px] rounded-[16px] shadow-[0_4px_4px_0_rgba(0,0,0,0.04)] flex flex-col gap-[16px]'>
      <div className={`h-[208px] p-[16px] bg-[url(src/assets/images/flights/flight1.jpg)] bg-cover rounded-t-[16px]`}>
        <div className='w-fit bg-grey100 py-[12px] px-[16px] rounded-[8px] font-[LilitaOne] text-[24px] leading-[28px]'>
          {t(FLIGHT_TICKET_PROPOSAL_STATUS_TRANSLATION_KEY_MAP[flightTicketRequest.computed_status])}
        </div>
      </div>
      <div className='p-[16px]'>
        <Title
          text={
            flightTicketRequest.amount_of_people == 1
              ? t('flights.flightTitleForOnePerson')
              : t('flights.flightTitle', { peopleNumber: flightTicketRequest.amount_of_people })
          }
        />
      </div>
    </div>
  );
};

export default FlightBox;
